export const FieldInsuredDefault = [
    ['insured_name', 'insured_name'],
    ['insured_surname', 'insured_surname'],
    ['phone', 'phone'],
    ['email', 'email'],
    ['notificationChannel', 'notification_channel'],
    ['sender', 'sender'],
    ['next_reminder', 'next_reminder']
].map(([key, value]) => ({
    label: value,
    type: 'string',
    properties: [key]
}));
